<template>
  <div>
    <scroller :on-refresh="refresh">
      <div class="container">
        <div class="row">
          <div class="col-md-8" style="margin: 0 auto">
            <mt-header title>
              <router-link to slot="left">
                <mt-button icon="back" @click.native="$router.back(-1)"
                  >本周排名</mt-button
                >
              </router-link>
            </mt-header>
            <div class="header">
              <div class="profile-box">
                <img :src="user.avatar" />
              </div>
              <div class="nickFile">
                <p class="text1">Hi，{{ user.nickName }}</p>
                <span v-show="userTime.rank"
                  >本周学习 {{ userTime.watchTime || 0 }} 分钟，排名第
                  {{ userTime.rank }} 位</span
                >
                <span v-show="!userTime.rank"
                  >您本周还未观看视频，暂无排名</span
                >
              </div>
              <div class="right-box" @click="getIndex">去学习</div>
            </div>
            <div
              v-for="item in weekRankList"
              :key="item.userId"
              class="timeList"
            >
              <span style="font-size: 16px" v-if="item.liveUsers">{{
                item.rank
              }}</span>
              <mt-cell :title="item.liveUsers.nickName" v-if="item.liveUsers">
                <span>本周学习 {{ item.watchTime }} 分钟</span>
                <img
                  slot="icon"
                  :src="item.liveUsers.avatar"
                  width="48"
                  height="48"
                  v-if="item.liveUsers.avatar"
                />
              </mt-cell>
            </div>
          </div>
        </div>
      </div>
    </scroller>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: '',
      weekRankList: [],
      user: {},
      userTime: {
        rank: '',
        watchTime: '',
      },
    }
  },

  mounted() {
    this.user = JSON.parse(sessionStorage.getItem('userInfo'))
    this.userId = sessionStorage.getItem('userId')
    this.getWeekRank()
    this.noShare()
  },
  methods: {
    refresh() {
      location.reload()
    },
    // 获取周排名列表
    getWeekRank() {
      this.$http({
        url: '/live/liveUserTime/getWeekRank',
        method: 'get',
        params: {
          userId: this.userId,
        },
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.weekRankList = this.weekRankList.concat(data.data)
          // 获得当前用户排名信息
          if (data.rankInfo) {
            const arr = data.rankInfo.split(',')
            this.userTime.rank = arr[0]
            this.userTime.watchTime = arr[1]
          }
        } else {
          this.weekRankList = []
        }
      })
    },
    getIndex() {
      this.$router.push('/')
    },
  },
}
</script>

<style lang='scss' scoped>
/deep/ .mint-cell-text {
  padding-left: 10px;
}
.timeList {
  display: flex;
  align-items: center;
  margin-left: 2rem;
  span {
    font-size: 12px;
  }
  /deep/ .mint-cell {
    width: 95%;
    padding: 1rem;
    /deep/ img {
      border-radius: 50%;
    }
  }
}
/deep/ .mint-cell-wrapper {
  background-image: none;
}
.header {
  height: 10rem;
  background: #eee;
  position: relative;
  box-sizing: border-box;
  padding: 10px;
  .profile-box {
    width: 48px;
    height: 48px;
    border: 2px solid #bfbfbf;
    border-radius: 50%;
    float: left;
    margin: 1rem;
    img {
      width: 100%;
      overflow: hidden;
      height: 100%;
      border-radius: 50%;
    }
  }
  .nickFile {
    float: left;
    margin: 1rem 0.4rem 0 0;
    line-height: 30px;
    .text1 {
      font-weight: 600;
      font-size: 16px;
    }
    span {
      color: #666;
      font-size: 12px;
    }
  }
  .right-box {
    font-size: 12px;
    padding: 2px 5px;
    border-radius: 5px;
    position: absolute;
    right: 1rem;
    margin: 3.5rem 0.2rem 0 0;
    background-color: $theme-color;
    color: #fff;
  }
}
</style>
